/* import __COLOCATED_TEMPLATE__ from './status-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';

interface CellStatusCellSignature {
  Args: {
    cell: unknown;
    column: unknown;
    row: unknown;
    scrollToRow: unknown;
  };
}

const CellStatusCellComponent = templateOnlyComponent<CellStatusCellSignature>();

export default CellStatusCellComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cell::StatusCell': typeof CellStatusCellComponent;
    'cell/status-cell': typeof CellStatusCellComponent;
  }
}
